import React, { Fragment } from "react";
import { Form, Row, Col, Tooltip, Divider } from "antd";
import { MinusCircleOutlined, PlusCircleFilled } from "@ant-design/icons";
import type { FormInstance } from "antd/es/form/Form";
import { ResponsibleUserSelectModal } from "./ResponsibleUserSelectModal";
import { User } from "../../../lib/interfaces";
import { AccountCreateActiveModal } from "../types/AccountCreateActiveModal";
import { CreateAccountData } from "../types/CreateAccountData";
import { RenderFields, RenderFormItem, RenderTitle } from "./ResponsibleUserTypes";
import { SetActiveModal } from "../../../lib/utils/useActiveModal";

interface ResponsibleUserFormItemProps {
  activeModal: AccountCreateActiveModal;
  setActiveModal: SetActiveModal<AccountCreateActiveModal>;
  formInstance: FormInstance<CreateAccountData>;
}

export const ResponsibleUserFormItem = (props: ResponsibleUserFormItemProps) => {
  const { activeModal, setActiveModal, formInstance } = props;

  const renderTitle: RenderTitle = (title, index) =>
    index === 0 ? (
      <div
        style={{
          fontSize: "13px",
          margin: "3px 0 5px 0",
          color: "rgba(0, 0, 0, 0.85)",
        }}
      >
        {title}
      </div>
    ) : null;

  const renderFormItem: RenderFormItem = (props) => {
    const { fieldName, formRecord, responsibleUserFormData, titleName, index } = props;
    const value = responsibleUserFormData?.[index]?.[fieldName];
    return (
      <>
        {renderTitle(titleName, index)}
        <Form.Item
          {...formRecord}
          name={[formRecord.name, fieldName]}
          className="form-item-required__hidden-error__mb0"
        >
          <span>{value}</span>
        </Form.Item>
      </>
    );
  };

  const renderFields: RenderFields = (fields, responsibleUserFormData, remove) => {
    return fields.map((formRecord, index) => {
      return (
        <Fragment key={formRecord.key}>
          <Row gutter={20} wrap={false}>
            <Col span={5}>
              {renderFormItem({
                formRecord,
                index,
                responsibleUserFormData,
                fieldName: "lastName",
                titleName: "Фамилия",
              })}
            </Col>
            <Col span={5}>
              {renderFormItem({
                formRecord,
                index,
                responsibleUserFormData,
                fieldName: "firstName",
                titleName: "Имя",
              })}
            </Col>
            <Col span={5}>
              {renderFormItem({
                formRecord,
                index,
                responsibleUserFormData,
                fieldName: "middleName",
                titleName: "Отчество",
              })}
            </Col>
            <Col span={4}>
              {renderFormItem({
                formRecord,
                index,
                responsibleUserFormData,
                fieldName: "email",
                titleName: "Email",
              })}
            </Col>
            <Col span={1}>
              <MinusCircleOutlined
                className="dynamic-delete-button minus-icon"
                style={{
                  marginTop: index === 0 ? "38px" : "10px",
                  marginLeft: "5px",
                }}
                onClick={() => {
                  remove(formRecord.name);
                }}
              />
            </Col>
          </Row>
        </Fragment>
      );
    });
  };

  return (
    <>
      <Row style={{ display: "flex", alignItems: "top", marginBottom: 0 }}>
        <Col span={4} style={{ display: "flex" }}>
          <h3>Менеджеры B2O</h3>
          <Tooltip title="Добавить менеджера">
            <PlusCircleFilled
              className="plus-icon"
              style={{ margin: "6px 0 0 8px" }}
              onClick={() => setActiveModal("responsibleSelect")}
            />
          </Tooltip>
        </Col>
      </Row>
      <Form.List name="responsibleUser">
        {(fields, { add, remove }) => {
          const addResponsibleUser = (user: User) => {
            add({
              id: user.id,
              lastName: user.userInfo.lastName,
              firstName: user.userInfo.firstName,
              middleName: user.userInfo.middleName,
              email: user.userInfo.email,
            });
          };

          const responsibleUserFormData: CreateAccountData["responsibleUser"] = formInstance.getFieldValue(
            "responsibleUser"
          );
          return (
            <>
              {renderFields(fields, responsibleUserFormData, remove)}
              <ResponsibleUserSelectModal
                visible={activeModal === "responsibleSelect"}
                setActiveModal={setActiveModal}
                onSubmit={addResponsibleUser}
                responsibleUserFormData={responsibleUserFormData}
              />
            </>
          );
        }}
      </Form.List>
      <Divider style={{ marginTop: "10px" }} />
    </>
  );
};
